import { FC, memo, useMemo } from 'react';
import { Badge, Menu, MenuButton, PatientsIcon, useMenu } from '@higo/ui';
import { useNewVisits } from 'store/visitsStore';
import { Link } from 'react-router-dom';
import { getDashboardChildRoute, routes } from 'routes';
import { FormattedMessage } from 'react-intl';
import { HeaderNewVisitsNotificationsMenuItem } from './HeaderNewVisitsNotificationsMenuItem';
import { HeaderNotificationMenuFooterMenuItem } from './HeaderNotificationMenuFooterMenuItem';
import { HeaderNotificationMenuHeaderMenuItem } from './HeaderNotificationMenuHeaderMenuItem';
import { HeaderNotificationMenuItem } from 'components/Header/HeaderNotificationMenu/HeaderNotificationMenuItem';
import { isEmpty } from 'rambda';
import { useQueryClient } from 'react-query';
import { DoctorQueryKey } from 'config/doctorQueryKey';

export const HeaderVisitsNotificationsMenu: FC = memo(() => {
  const { isOpened, anchorEl, toggle, close } = useMenu();
  const newVisits = useNewVisits();
  const newVisitsSlice = useMemo(
    () => newVisits.slice(0, 2),
    [newVisits],
  );
  const queryClient = useQueryClient();

  const handleClick = () =>
    window.location.pathname.includes('dashboard/visits')
      ? window.location.reload()
      : queryClient.invalidateQueries(
          DoctorQueryKey.UnassignedVisitsList,
        );

  return (
    <>
      <MenuButton
        id="visits-button"
        menuId="visits-menu"
        isMenuOpened={isOpened}
        onClick={toggle}
      >
        <Badge count={newVisits.length}>
          <PatientsIcon size={18} />
        </Badge>
      </MenuButton>

      <Menu id="visits-menu" anchorEl={anchorEl} open={isOpened} onClose={close}>
        <HeaderNotificationMenuHeaderMenuItem>
          <div id="visits-notification-title">
            <FormattedMessage id="header.notifications.visits.title" />
          </div>
        </HeaderNotificationMenuHeaderMenuItem>

        {isEmpty(newVisitsSlice) && (
          <HeaderNotificationMenuItem disabled id="visits-empty-info">
            <FormattedMessage id="header.notifications.visits.empty" />
          </HeaderNotificationMenuItem>
        )}

        {newVisitsSlice.map((visitId) => (
          <HeaderNewVisitsNotificationsMenuItem
            key={visitId}
            visitId={visitId}
            id={`visit-${visitId}-title`}
            onClose={close}
          />
        ))}

        <HeaderNotificationMenuFooterMenuItem>
          <Link
            to={getDashboardChildRoute(routes.dashboard.visits)}
            state={{ prevPath: 'seeAll' }}
            id="see-all-visits-link"
            onClick={handleClick}
          >
            <FormattedMessage id="header.notifications.seeAll" />
          </Link>
        </HeaderNotificationMenuFooterMenuItem>
      </Menu>
    </>
  );
});
